class KlevuTrigger extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger () {
    const searchEl = this.externalEls.search.element

    window.setTimeout(() => {
      searchEl.focus()
    }, 0)
  }
}

if (!customElements.get('klevu-trigger')) {
  customElements.define('klevu-trigger', KlevuTrigger)
}
